"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = exports.deepCopy = exports.argMax = exports.range = exports.func_mean = exports.func_sum = exports.zip = void 0;
var zip = function (arr) {
    var arrs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        arrs[_i - 1] = arguments[_i];
    }
    return arr.map(function (val, i) { return arrs.reduce(function (a, arr) { return __spreadArray(__spreadArray([], a), [arr[i]]); }, [val]); });
};
exports.zip = zip;
function func_sum(array) {
    var sum1 = array.reduce(function (accumulator, currentValue) { return accumulator + currentValue; });
    return sum1;
}
exports.func_sum = func_sum;
function func_mean(array) {
    var suma = 0;
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var x = array_1[_i];
        suma += x;
    }
    var mean = suma / array.length;
    return mean;
}
exports.func_mean = func_mean;
function range(start, stop, step) {
    if (typeof stop == 'undefined') {
        // one param defined
        stop = start;
        start = 0;
    }
    if (typeof step == 'undefined') {
        step = 1;
    }
    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
    }
    var result = [];
    for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
    }
    return result;
}
exports.range = range;
function argMax(array) {
    return array.map(function (x, i) { return [x, i]; }).reduce(function (r, a) { return (a[0] > r[0] ? a : r); })[1];
}
exports.argMax = argMax;
function deepCopy(obj) {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj)
        return obj;
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr))
                copy[attr] = deepCopy(obj[attr]);
        }
        return copy;
    }
}
exports.deepCopy = deepCopy;
function truncate(val, low, high) {
    if (low === void 0) { low = 0; }
    if (high === void 0) { high = 1; }
    var truncatedVal = val;
    if (val < low) {
        truncatedVal = low;
    }
    else if (val > high) {
        truncatedVal = high;
    }
    return truncatedVal;
}
exports.truncate = truncate;
